// Markdown minimal pour les pages légales (champ « Texte enrichi (Markdown) » de
// Strapi) : titres ###/####, **gras**, listes « - », [lien](url), paragraphes
// séparés par une ligne vide, retour à la ligne simple conservé. Les adresses
// e-mail et les liens www./https:// deviennent cliquables.
//
// Le texte est échappé AVANT la mise en forme : aucune balise saisie dans l'admin
// n'est interprétée (sortie sûre pour v-html), et seules les URL http(s), mailto,
// relatives (/…) ou d'ancre (#…) sont acceptées dans les liens.
import { rich } from './rich'

const SAFE_URL = /^(https?:\/\/|mailto:|\/|#)/i

function inline(text) {
  const links = []
  // 1. liens explicites [texte](url), mis de côté pour ne pas être re-liés
  let out = rich(text).replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (m, label, url) => {
    if (!SAFE_URL.test(url)) return label
    const ext = /^https?:/i.test(url)
    links.push(`<a href="${url}"${ext ? ' target="_blank" rel="noopener"' : ''}>${label}</a>`)
    return `@@LINK${links.length - 1}@@`
  })
  // 2. adresses e-mail et URL nues
  out = out
    .replace(/[\w.+-]+@[\w-]+(\.[\w-]+)+/g, (m) => `<a href="mailto:${m}">${m}</a>`)
    .replace(/\b((?:https?:\/\/|www\.)[^\s<]+[^\s<.,;:!?)])/g, (m) => {
      const href = /^https?:/i.test(m) ? m : `https://${m}`
      return `<a href="${href}" target="_blank" rel="noopener">${m}</a>`
    })
  // 3. retours à la ligne simples
  out = out.replace(/\n/g, '<br>')
  return out.replace(/@@LINK(\d+)@@/g, (m, i) => links[Number(i)])
}

export function markdown(text) {
  const blocks = String(text || '').replace(/\r/g, '').split(/\n[ \t]*\n/)
  return blocks
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => {
      const heading = /^(#{2,4})\s+(.+)$/.exec(block)
      if (heading && !block.includes('\n')) {
        const level = Math.min(heading[1].length + 1, 5)   // ## -> h3, ### -> h4, #### -> h5
        return `<h${level}>${inline(heading[2])}</h${level}>`
      }
      const lines = block.split('\n')
      if (lines.every((l) => /^\s*[-•]\s+/.test(l))) {
        return `<ul>${lines.map((l) => `<li>${inline(l.replace(/^\s*[-•]\s+/, ''))}</li>`).join('')}</ul>`
      }
      return `<p>${inline(block)}</p>`
    })
    .join('')
}
